<template>
  <div class="upper-subpanel--inside">
    <div class="col-6">
      <DrugInfo/>
    </div>
    <div class="col-6">
      <div class="confirm-layout">
        <div class="alert alert-success">
          此藥物總數量: {{ selectedDrugTotalAmount }} 
          <span class="float-right">(新增位置: {{selectedDevicesID.indexOf(currentDevice.id.toString()) + 1}}/{{selectedDevicesID.length}})</span>
        </div>
        <confirmFlow 
        v-if="currentProgress === 'confirm'"
        :confirmProgress="confirmProgress"
        v-on:confirmationFinish="getConfirmData"></confirmFlow>
        <set-min-storage 
          v-if="currentProgress === 'setMinStorage'" 
          v-on:setNum="getMinStorage" 
          :defaultAmount="minStorage"
          :canBeZero="true"
          :inputLabel="'更新安全存量'" />
      </div>
    </div>
  </div>
</template>

<script>
import MultiFlowBase from '../ComponentBase/MultiFlowBase';
import confirmFlow from './ConfirmFlow';
import DrugInfo from '../flowComp/DrugInfo';
import setMinStorage from '../flowComp/NumberSet';

export default {
  name: 'CreateDrugMultiFlow',
  extends: MultiFlowBase,
  components: {
    confirmFlow,
    DrugInfo,
    setMinStorage,
  },
  data() {
    return {
      minStorage: 0,
      currentDrugInSystem: {},
    };
  },
  computed: {
    selectedDevicesID() {
      return this.$store.state.device.selectedDevicesID;
    },
    selectedDrug() {
      return this.$store.state.drug.selectedDrug;
    },
    selectedDrugTotalAmount() {
      return this.$store.state.drug.selectedDrugTotalAmount;
    },
  },
  mounted() {
    // init the first of selected devices.
    this.$store.commit('SET_CURRENT_DEVICE_FROM_SELECTED', this.selectedDevicesID[0]);
    this.$store.commit('SET_CURRENT_STEP', 'setMaxStock');
  },
  methods: {
    async getConfirmData() {
      console.log('get confirm data, next Device:', this.nextDevice);
      if (this.nextDevice !== null) {
        // check whether next index is over the keys' array length
        this.$store.commit('SET_CURRENT_DEVICE_FROM_SELECTED', this.nextDevice.id);
        this.$store.commit('SET_CURRENT_STEP', 'setMaxStock');
        this.resetProgress();
      } else {
        console.log('leave multiflow.');
        await this.getCurrentDrugInSystem();
        await this.$store.dispatch('getTotalDrugAmountInstanly', this.selectedDrug.id);
        this.$store.commit('SET_CURRENT_STEP', 'setMinStorage');
        this.nextProgress();
      }
    },
    async getMinStorage(val) {
      this.minStorage = val;
      this.setMinStock()
      .then((res) => {
        this.$emit('setAllConfirmData');
      })
      .catch((err) => {
        console.log(err);
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: `安全存量不可大於總最大庫存量: ${err.response.data.max_stock}`,
        });
      });
    },
    getCurrentDrugInSystem() {
      return this.instance.get(`/api/total-storage-in-system/?medication=${this.selectedDrug.id}`)
      .then((res) => {
        this.currentDrugInSystem = res.data.results[0];
        this.minStorage = res.data.results[0].min_stock;
      });
    },
    setMinStock() {
      return this.instance.patch(`/api/total-storage-in-system/${this.currentDrugInSystem.id}/`, {
        min_stock: this.minStorage,
      });
    },
  },
};
</script>





// WEBPACK FOOTER //
// MultiFlow.vue?0c359585